import { AuthProvider } from './routerProvider/authContext';
import { CollapseMenuProvider } from './routerProvider/collapseMenuContext';
import { IsLoginProvider } from './routerProvider/isLoginContext';
import { ListTabProvider } from './routerProvider/ListTabContext/ListTabProvider';
import { RouterProvider } from './routerProvider/routerContext';
import { ThemeProvider } from './routerProvider/themeContext';

export function ProvidersContext({
  children,
}: {
  readonly children: React.ReactNode;
}) {
  return (
    <AuthProvider>
      <RouterProvider>
        <IsLoginProvider>
          <ThemeProvider>
            <CollapseMenuProvider>
              <ListTabProvider>{children}</ListTabProvider>
            </CollapseMenuProvider>
          </ThemeProvider>
        </IsLoginProvider>
      </RouterProvider>
    </AuthProvider>
  );
}
